import React, { useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { colleagueStatus, status } from 'constants/Helpers';
import Lightbox from 'react-image-lightbox';
// SVG
import WarningIcon from 'assets/images/svg/WarningIcon';
// Components
import ChangeStatusBtn from 'components/productionJobs/ChangeStatusBtn';
// Actions
import { setOrderDetailsAllData } from 'store/productionJob/ProductionJobActions';
// Selectors
import { getQcImagesData } from 'store/productionJob/ProductionJobSelectors';

const OrderDetailsCard = ({ orderDetails, hasSubmittedBefore, hasDeviation }) => {
  const dispatch = useDispatch();
  const qcImages = useSelector((state) => getQcImagesData({ state }));
  const [isImgOpen, setIsImgOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const editDeviationEnabled = true;

  const fetchOrderDetails = (orderId) => {
    dispatch(setOrderDetailsAllData(orderId));
  };

  return (
    <div className="card orderDetails-card">
      <div className="card-body">
        <div className="order-id-col">
          <h6 className="order-id-text">Created Date</h6>
          <h6 className="order-id-value">
            {moment(orderDetails?.creationDate).format('DD/MM/YYYY')}
          </h6>
        </div>
        <div className="order-id-col">
          <h6 className="order-id-text">Production Job</h6>
          <h6 className="order-id-value">{orderDetails?.id}</h6>
        </div>
        <div className="order-id-col">
          <h6 className="order-id-text">VM ID</h6>
          <h6 className="order-id-value">{orderDetails?.vmSerialId}</h6>
        </div>

        {orderDetails?.floristDto && orderDetails?.floristDto?.name && (
          <div className="order-id-col">
            <h6 className="order-id-text">{orderDetails?.floristDto?.name ?? ''}</h6>
            <h6 className="order-id-value">
              {orderDetails?.status !== null ? colleagueStatus[orderDetails?.status] : ''}
            </h6>
          </div>
        )}
        <div
          className={`order-status-col ${
            Array.isArray(status[orderDetails?.status ?? 6]) ? 'order-status-col-btns' : ''
          }`}
        >
          <ChangeStatusBtn
            item={orderDetails}
            fetchMoreData={fetchOrderDetails}
            details={true}
            showAllCTA={true}
            hasSubmittedBefore={hasSubmittedBefore}
            hasDeviation={hasDeviation}
          />
        </div>
        {qcImages?.length > 0 && (
          <div className="qc-images-wrapper">
            <h4>Quality Check</h4>
            <div className="qc-attachments">
              {qcImages?.map((el) => (
                <img
                  key={el}
                  className="qc-img"
                  src={el}
                  alt="qcImg"
                  onClick={() => {
                    setIsImgOpen(true);
                    setImageSrc(el);
                  }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      {editDeviationEnabled &&
        orderDetails?.preparedPreviously &&
        orderDetails?.preparationStatus !== 0 && (
          <div className="header-disclaimer order-details-disclaimer">
            <WarningIcon />{' '}
            <p>This order was prepared once. Check with supervisor before moving ahead.</p>
          </div>
        )}
      {isImgOpen && <Lightbox onCloseRequest={() => setIsImgOpen(false)} mainSrc={imageSrc} />}
    </div>
  );
};

export default OrderDetailsCard;
